export default __webpack_public_path__ + "img/cwVBWENX.bb3714fa.svg";